import { usersRepo } from '@/constants/providers';
import { PaginationParams } from '@/shared/types';
import { useQuery } from '@tanstack/react-query';
import { UserKey } from './types';

type UseGetUserAdminPrivilegesProps = {
  userId: number;
} & PaginationParams;

export const useGetUserAdminPrivileges = ({
  userId,
  filter,
  pageNumber,
  sortBy,
  sortOrder,
}: UseGetUserAdminPrivilegesProps) => {
  return useQuery({
    queryKey: UserKey.ADMIN_PRIVILEGES_PAGE(userId, {
      filter,
      pageNumber,
      sortBy,
      sortOrder,
    }),
    queryFn: () =>
      usersRepo.getAdminPrivilegesByUserId(userId, {
        filter,
        pageNumber,
        sortBy,
        sortOrder,
      }),
    cacheTime: 1000 * 60 * 5,
  });
};
